module.exports = __webpack_public_path__ + "img/icon_account_binding.4c254445.png";